import {
  Avatar as NextUIAvatar,
  type AvatarProps,
} from "@nextui-org/avatar";

export function Avatar(props: AvatarProps) {
  return <NextUIAvatar {...props} />;
}

export type { AvatarProps };
